import { Flex, Input, Text, Box } from "@chakra-ui/react";

export default function ShippingDetailsForm(props: {
  shippingRecipient?: string;
  shippingStreet?: string;
  shippingCity?: string;
  shippingZip?: string;
  shippingState?: string;
  shippingCountry?: string;
  onChangeShippingRecipient?: (value: string) => void;
  onChangeShippingStreet?: (value: string) => void;
  onChangeShippingCity?: (value: string) => void;
  onChangeShippingZip?: (value: string) => void;
  onChangeShippingState?: (value: string) => void;
  onChangeShippingCountry?: (value: string) => void;
}) {
  const {
    shippingRecipient,
    shippingStreet,
    shippingCity,
    shippingZip,
    shippingState,
    shippingCountry,
    onChangeShippingRecipient,
    onChangeShippingStreet,
    onChangeShippingCity,
    onChangeShippingZip,
    onChangeShippingState,
    onChangeShippingCountry,
  } = props;

  const sharedInputProps = {
    bg: "#FFFFFF",
    border: "1px solid #E6ECF3",
    borderRadius: "12px",
    fontSize: "16px",
    h: "48px",
    px: "20px",
    _hover: {},
    focusBorderColor: "#2F80ED",
    _focusVisible: { border: "1px solid #2F80ED", boxShadow: "none" },
  } as const;

  return (
    <Box mb="16px" p={{ base: "14px", md: "16px" }} borderRadius="12px" border="1px solid #E6ECF3" bg="#FFF">
      <Text fontSize="16px" lineHeight="24px" fontWeight="600" color="#0B0E10">
        Shipping details
      </Text>

      <Flex direction="column" gap="12px" mt="12px">
        <Input
          value={shippingRecipient || ""}
          onChange={(e) => onChangeShippingRecipient?.(e.target.value)}
          placeholder="Recipient Name"
          {...sharedInputProps}
        />
        <Input
          value={shippingStreet || ""}
          onChange={(e) => onChangeShippingStreet?.(e.target.value)}
          placeholder="Street Address"
          {...sharedInputProps}
        />
        <Flex gap="12px" direction={{ base: "column", md: "row" }}>
          <Input
            value={shippingCity || ""}
            onChange={(e) => onChangeShippingCity?.(e.target.value)}
            placeholder="City"
            {...sharedInputProps}
          />
          <Input
            value={shippingZip || ""}
            onChange={(e) => {
              const raw = e.target.value ?? "";
              const digitsOnly = String(raw).replace(/\D+/g, "");
              onChangeShippingZip?.(digitsOnly.slice(0, 5));
            }}
            placeholder="Zip Code"
            inputMode="numeric"
            maxLength={5}
            {...sharedInputProps}
          />
        </Flex>
        <Input
          value={shippingState || ""}
          onChange={(e) => onChangeShippingState?.(e.target.value)}
          placeholder="State"
          {...sharedInputProps}
        />
        <Input
          value={shippingCountry || ""}
          onChange={(e) => onChangeShippingCountry?.(e.target.value)}
          placeholder="Country"
          {...sharedInputProps}
        />
      </Flex>
    </Box>
  );
}
